import React from 'react';
import BannerSlider from './BannerSlider';
import { Link } from 'react-router-dom';
import Image from '../../components/general/Image';
import { ROUTES } from '../../routes/RouteList';
import { StartHiring, StarWhite, StarOrange, StarBlue } from '../../constants/ImagePaths';
import { CodingBackground } from '../../constants/ImagePaths';

const BannerSection = () => {
  const backgroundStyle = {
    backgroundImage: `url(${CodingBackground})`,
    backgroundSize: 'contain',
    backgroundPosition: 'initial'
  }

  return (
    <section className="text-center !py-[50px]" style={backgroundStyle}>
      <div className="--layout-padding max-width">
        <div className="">
          <div className="text-[25px] md:text-[40px] lg:text-[3rem] font-bold">
            <div>
              <div className='text-center'>
                <Image src={StarOrange} alt="banner-title" className="hidden md:inline-block translate-y-[-25px] translate-x-[-30px]" lazyLoad={false} />
                Accelerate Development with
              </div>
              <div className='lg:ml-[65px] text-center'>
                <Image src={StarWhite} alt="banner-title" className="hidden md:inline-block translate-y-[-20px] translate-x-[-30px]" lazyLoad={false} />
                <span className='text-[#0e96ff]'>Top-Tier</span> Engineers
                <Image src={StarBlue} alt="banner-title" className="hidden md:inline-block translate-y-[10px] translate-x-[30px]" lazyLoad={false} />
              </div>
            </div>
          </div>

          <div className="mt-[30px] text-center text-[16px] md:text-[1rem] font-extralight lg:w-[70%] mx-auto">
            Quickly hire thoroughly vetted developers—on time, within budget, <br className='hidden lg:block' /> and with month-to-month flexibility. 
          </div>


          <div className="mt-[30px] lg:mt-[30px] grid grid-cols-2 lg:flex lg:flex-row lg:justify-center lg:w-[85%] lg:mx-auto lg:items-start">
            <div className="p-4 flex items-center justify-center flex-col gap-2 lg:ml-[30px]">
              <h5 className="font-semibold text-primary-color text-[1.6rem] text-center">100+</h5>
              <div className="text-[12px] -mt-[8px] text-nowrap">
                Companies trust our talent
              </div>
            </div>

            <div className='flex justify-start items-baseline min-h-[100px]'> 
              <hr className='hidden lg:block lg:rotate-90 lg:w-[40px] border-gray-600' />
              <div className="p-4 flex items-center justify-center flex-col gap-0 lg:w-[90%]">
                <h5 className="font-semibold text-primary-color text-[1.6rem]">95%</h5>
                <div className="text-[12px] text-nowrap">
                  Client retention rate
                </div>
              </div>
            </div>

            <div className='flex justify-start items-baseline  min-h-[100px]'>
              <hr className='hidden lg:block lg:rotate-90 lg:w-[40px] border-gray-600' />
              <div className="p-4 flex items-center justify-center flex-col gap-2 lg:w-[90%]">
                <h5 className="font-semibold text-primary-color text-[1.6rem]">1.8M+</h5>
                <div className="text-[12px] text-nowrap -mt-[10px]">
                  Hours Logged and Counting
                </div>
              </div>
            </div>

            <Link className="md:py-0 lg:ml-[30px]" to={ROUTES.START_HIRING}>
              <Image className="w-[140px]" src={StartHiring} alt="arrow-right" lazyLoad={false} />
            </Link>
          </div>
        </div>
      </div>

      <div className="mt-[30px] max-width">
        <BannerSlider />
      </div>
    </section>
  );
};

export default BannerSection;